import React, { lazy } from 'react';

export const LazyCredentialsSection = lazy(() => import('../CredentialsSection'));